<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <div class="container-fluid">
    <RotaModal :disabled="disabled" :moment-day="today" :appointment="appointment" :button-msg="buttonMsg"
               :title-msg="titleMsg"
               :trigger-modal="show" @rotachange="rotaChange" @showModal="changeShow"
               @deleterota="deleteRota"></RotaModal>
    <MapModal @closemap="showMap = false"
              :lat="lat" :lon="lon" :display-name="displayName"
              :ver-lat="valLat" :ver-lon="valLon" :ver-display-name="valDisplayName"
              v-if="showMap"></MapModal>
    <div class="row">
      <div class="col-12">

        <svg onclick="window.print();return false;" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
             fill="currentColor" class="bi bi-printer-fill" viewBox="0 0 16 16">
          <title>Print the Schedule</title>
          <path
              d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
          <path
              d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
        </svg>
        &nbsp;&nbsp;Schedule below is scrollable
      </div>
    </div>

    <div class="row schedule text-center">
      <table class="table table-striped table-bordered">
        <schedule-line-header @choosetoday="setToday" @rotachosen="showRota" :show-pay="(showPay==='true')"
                              :moment="moment"></schedule-line-header>
        <tbody v-if="loggedInUser && loggedInUser.isAdmin">
        <schedule-line @show-map="showMapMethod" @choosetoday="setToday" @rotachosen="showRota"
                       :show-pay="(showPay ==='true')"
                       v-for="emp of users" :key="emp" :employee="emp" :moment="moment"></schedule-line>
        <schedule-total-line :show-pay="(showPay ==='true')" :moment="moment"></schedule-total-line>
        </tbody>
        <tbody v-else>
        <schedule-line @rotachosen="showRota" @show-map="showMapMethod" :show-pay="(showPay ==='true')"
                       :employee="loggedInUser" :moment="moment"></schedule-line>
        <schedule-total-line :show-pay="(showPay ==='true')" :moment="moment"></schedule-total-line>
        </tbody>
      </table>
    </div>

    <div class="row" v-show="loggedInUser && loggedInUser.isAdmin">
      <div class="col-12">
        <label for="showPay">Show Pay?&nbsp;</label>
        <input id="showPay" type="radio" v-model="showPay" value="true">&nbsp;Yes
        <input type="radio" v-model="showPay" value="false">&nbsp;No
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleLine from "../views/ScheduleLine";
import ScheduleLineHeader from "../views/ScheduleLineHeader";
import RotaModal from "../components/RotaModal";
import {Appointment} from "../classes/Appointment";
import moment from "moment";
import ScheduleTotalLine from "./ScheduleTotalLine";
import MapModal from "../components/MapModal";

export default {
  name: "Schedule",
  components: {MapModal, ScheduleTotalLine, ScheduleLineHeader, ScheduleLine, RotaModal},
  data() {
    return {
      disabled: false,
      showMap: false,
      showPay: false,
      buttonMsg: "",
      titleMsg: "",
      show: false,
      appointment: new Appointment(),
      rota: {},
      today: new moment().startOf("day"),

      lat: 0,
      lon: 0,
      displayName: "",

      valLat: 0,
      valLon: 0,
      valDisplayName: "",
    }
  },
  props: {
    moment: {
      type: Object,
      required: true,
    },
  },
  methods: {

    showMapMethod(arg) {
      // arg is a rota
      let rota = arg;
      if (rota.checkin.place_id !== 0) {
        this.lat = parseFloat(rota.checkin.lat);
        this.lon = parseFloat(rota.checkin.lon);
        this.displayName = rota.checkin.display_name;
        this.valLat = rota.validateCheckin ? parseFloat(rota.validateCheckin.lat) : 0;
        this.valLon = rota.validateCheckin ? parseFloat(rota.validateCheckin.lon) : 0;
        this.valDisplayName = rota.validateCheckin ? rota.validateCheckin.display_name : "";

        this.showMap = true;
      }
    },

    setToday(arg) {
      this.today = arg;
    },

    rotaChange(arg) {

      this.$emit("rotachange", arg); // emit to home
    },
    deleteRota(arg) {
      //console.log("Day emitting delete ..")
      this.$emit("deleterota", arg); // emit to home
    },
    changeShow(arg) {
      ////console.log("should change show..");
      this.show = arg;

      this.rota.showModal = this.show; // do I need to do this here?

    },

    showRota(arg) {
      //console.log("show rota method")
      this.appointment = arg;
     // console.log("scheduler appt:")
      //console.log(this.appointment)

      if (arg.id !== this.appointment.DEFAULT_ID) {
        if (this.loggedInUser.isAdmin) {
          this.titleMsg = "Edit The Schedule Item";
          this.buttonMsg = "Edit";
          this.disabled = false;
        } else {
          this.titleMsg = "Check-In For Scheduled Item";
          this.buttonMsg = "Check-In";
          this.disabled = true;

        }
      } else {
        if (this.loggedInUser.isAdmin) {
          this.titleMsg = "Create a new Schedule Item";
          this.buttonMsg = "Add";
          this.disabled = false;
        }
      }
      if (this.appointment.checkin.display_name !== "" || this.loggedInUser.isAdmin) {
        this.show = true;
      }
    }
  },
  computed: {
    loggedInUser() {
      return this.$store.state.loggedInUser;
    },
    users() {
      return this.$store.state.users;
    }
  },
}
</script>


<style scoped>

.schedule {
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: auto;
  background-color: white;
}

@media print {
  body * {
    visibility: hidden;

  }

  .schedule, .schedule * {
    visibility: visible;
    height: auto !important
  }

  .schedule {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 8px;

  }
}

</style>
